import { render, staticRenderFns } from "./tokenProfit.vue?vue&type=template&id=654da03e"
import script from "./tokenProfit.vue?vue&type=script&lang=js"
export * from "./tokenProfit.vue?vue&type=script&lang=js"
import style0 from "./tokenProfit.vue?vue&type=style&index=0&id=654da03e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports